import { FailedToLoad } from '@ms/yammer-error-components';
import ThirdPartyCookiesDisabled from '@ms/yammer-web-components/dist/error/ThirdPartyCookiesDisabled';
import { isThirdPartyCookieError } from '@ms/yammer-web-support/dist/cookies';
import type { FC } from 'react';
import React from 'react';

export interface AppErrorProps {
  readonly error: unknown;
}

export const AppError: FC<AppErrorProps> = ({ error }) =>
  isThirdPartyCookieError(error) ? <ThirdPartyCookiesDisabled /> : <FailedToLoad />;
